import { useState, useEffect, useRef } from "react"
import { useEmailPlainMutation } from "./emailsApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import { Editor } from "@tinymce/tinymce-react"



const UserEmailForm = ( {user} ) => {

	const navigate = useNavigate()
    const editorRef = useRef(null);

    const [sendTo, setSendTo] = useState(user.email)
    const sendFrom = 'webmaster@smidtmanagement.com'
    const [replyTo, setReplyTo] = useState('pieter@smidtmanagement.com')
    const [subjectText, setSubjectText] = useState('')
    const [htmlText, setHtmlText] = useState('')


    const [emailUser, {data}] = useEmailPlainMutation()

    useEffect(() => {
		if(data) {
            if (data.message) {
                toast.error(<>Email was NOT Send:<br/>{data.message}</>);
			} else {
				setSubjectText('')
				toast.success("Email was Send");
				navigate(`/dash/users`)
			}	
		}

    }, [data, navigate])
    

    const onSendToChanged = e => setSendTo(e.target.value)
    const onReplyToChanged = e => setReplyTo(e.target.value)
    const onSubjectChanged = e => setSubjectText(e.target.value)

	let canSave
	canSave = [sendTo, sendFrom, replyTo, subjectText, htmlText].every(Boolean)

    const onEmailUserClicked = async (e) => {
		e.preventDefault()

		if(canSave) {
			await emailUser({ sendTo, sendFrom, replyTo, subjectText, htmlText})
		} else {
			toast.error('All fields are required');
		}
    }


    const content = (
        <section id="main_content">
            <header>
                <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faEnvelope} style={{fontSize:"30px", marginRight:"5px"}} />Email User</h1>
            </header>
            <main>
                <form onSubmit={e => e.preventDefault()}>
                    <div className="row mb-3">
                        <div className="col-md-5">
                            <label className="form-label" htmlFor="sendTo">
                                Send To:
                            </label>
                            <input
                                className="form-control"
                                id="sendTo"
                                name="sendTo"
                                type="text"
                                autoComplete="off"
                                value={sendTo}
                                onChange={onSendToChanged}
                            />
                        </div>
                        <div className="col-md-5">
                            <label className="form-label" htmlFor="replyTo">
                                Reply To:
                            </label>
                            <input
                                className="form-control"
                                id="replyTo"
                                name="replyTo"
                                type="text"
                                autoComplete="off"
                                value={replyTo}
                                onChange={onReplyToChanged}
                            />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-10">
                            <label className="form-label" htmlFor="subject">
                                Subject:
                            </label>
                            <input
                                className="form-control"
                                id="subject"
                                name="subject"
                                type="text"
                                autoComplete="off"
                                value={subjectText}
                                onChange={onSubjectChanged}
                            />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-10">
                            <Editor
                                apiKey="mprrt6hl7gkebqsue1jr2da25cai059a5vwnw9xtv4smrptk"
                                onInit={(evt, editor) => (editorRef.current = editor)}
                                value={htmlText}
                                onEditorChange={(newContent) => setHtmlText(newContent)}
                                init={{
                                    skin: (localStorage.getItem('theme')==='dark' ? "oxide-dark" : "oxide"),
                                    content_css: (localStorage.getItem('theme')==='dark' ? "dark" : "default"),
                                    height: 500,
                                    menubar: true,
                                    plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                                    toolbar: 'align | numlist bullist indent outdent | bold italic underline strikethrough backcolor fontsize | undo redo | blocks fontfamily | link image media table | emoticons charmap | removeformat',
                                }}
                            />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-10 text-end">
                            <br/>
                            <span
                                role="button"
                                className="p-2 text-secondary icon"
                                title="Send Email"
                                onClick={onEmailUserClicked}
                            >
                                Send Email
                                <FontAwesomeIcon icon={faEnvelope}  className="fa-icon"/>
                            </span>
                        </div>
                    </div>
                </form>

            </main>
        </section>
    )

    return content


}


export default UserEmailForm